import { useEffect } from 'react';

const usePageTitle = (title) => {

  useEffect(() => {
    document.title = `Epicplay - ${title || 'Instant win game provider'}`;

    return () => {
      document.title = 'Epicplay - Instant win game provider';
    }
  }, [title]);
};

export {
  usePageTitle,
}
